import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { Route, Redirect, Link, useLocation } from "react-router-dom";
import {
  Row,
  Col,
  Table,
  Form,
  Input,
  Switch,
  Select,
  Checkbox,
  Button,
  Modal,
  Cascader,
  message,
  Slider,
  InputNumber,
  Tag,
  Upload,
  DatePicker,
  Progress,
} from "antd";
import cookie from "react-cookies";
import "./list.less";
import {
  ExclamationCircleOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import moment from "moment";
import qs from "qs";
import { GET_TASK_LIST, SET_TASK } from "../../api/task";
import { base } from "../../api/config";
import { useTranslation } from "react-i18next";
import html2canvas from "html2canvas";

const { RangePicker } = DatePicker;

const List = () => {
  const { t } = useTranslation();
  const [filterForm] = Form.useForm();

  const listRef = useRef();

  const [pagination, setPagination] = useState({
    pageSize: 10,
    pageNo: 1,
    total: 0,
  });

  const [dataSource, setDataSource] = useState([{}]);
  const { pathname } = useLocation();
  const columns = [
    // {
    //   title: t("pages.taskList.columns1"),
    //   dataIndex: "no",
    //   key: "no",
    // },
    {
      title: t("pages.taskList.columns2"),
      dataIndex: "create_time",
      key: "create_time",
    },
    {
      title: t("pages.taskList.columns3"),
      dataIndex: "status",
      key: "status",
      render: (text, data) =>
        (text == 0 && t("pages.taskList.columns3Text0")) ||
        (text == 1 && t("pages.taskList.columns3Text1")) ||
        (text == 2 && t("pages.taskList.columns3Text2")) ||
        (text == 3 && t("pages.taskList.columns3Text3")) ||
        "",
    },
    {
      title: t("pages.taskList.columns4"),
      dataIndex: "file",
      key: "file",
    },
    {
      title: t("pages.taskList.columns5"),
      dataIndex: "execution_time",
      key: "execution_time",
    },
    {
      title: t("pages.taskList.columns6"),
      dataIndex: "finish",
      key: "finish",
      render: (text, data) => (
        <div
          style={{
            width: "100%",
            minWidth: "230px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Progress
            status="active"
            strokeColor={{
              "0%": "#108ee9",
              "100%": "#87d068",
            }}
            percent={text}
            size="small"
            style={{ width: "100%" }}
          />
        </div>
      ),
    },
    {
      title: t("pages.taskList.columns7"),
      dataIndex: "result",
      key: "result",
      render: (text, data) =>
        (text == 1 && t("pages.taskList.columns7Text1")) ||
        (text == -1 && t("pages.taskList.columns7Text2")) ||
        (text == "成功" && t("pages.taskList.columns7Text1")) ||
        (text == "失败" && t("pages.taskList.columns7Text2")) ||
        "",
    },
    {
      title: t("pages.taskList.columns8"),
      key: "action",
      render: (text, data, index) => {
        return (
          (data.status == 2 && (
            <div>
              <Button
                type="link"
                size="small"
                className="mr-3"
                href={`/index/task/detail?file=${data.file}&pdf=${data.pdf}`}
              >
                {t("pages.taskList.columns8Btn1")}
              </Button>
              {/* <Button
                type="link"
                size="small"
                href={`${base}/task/${data?.pdf}`}
                target="_blank"
                download={data?.pdf}
              >
                {t("pages.taskList.columns8Btn2")}
              </Button> */}
            </div>
          )) ||
          ""
        );
      },
    },
  ];

  const getList = async (paginations) => {
    const {
      data: { code, data, msg },
    } = await GET_TASK_LIST({
      ...paginations,
      per_page: paginations.pageSize,
      page: paginations.pageNo,
    });

    if (code == 200) {
      setDataSource(data.data);
      setPagination({
        ...pagination,
        total: data.total,
      });
    }
  };
  const paginationChange = (pages) => {
    setPagination({
      ...pagination,
      pageNo: pages.current || 1,
      current: pages.current,
    });
    getList({
      ...pagination,
      pageNo: pages.current || 1,
      current: pages.current,
    });
    // console.log("pageNo: ", pages);
  };

  useEffect(() => {
    getList(pagination);
    listRef.current = setInterval(() => {
      getList(pagination);
    }, 60000);

    return () => clearInterval(listRef.current);
  }, []);

  return (
    <div className="task list">
      <div className="btn-box mb-3">
        <Button type="primary" href="/index/task/create" className="mr-3">
          {t("pages.taskList.createBtn")}
        </Button>
        <span className="ml-3">
          {t("pages.taskList.taskTotal")}：{pagination.total}
        </span>
      </div>
      <div className="table-action mb-3">
        <Form
          layout="inline"
          onValuesChange={(cVal, vals) => {
            console.log(cVal, vals);
            let where = {
              ...pagination.where,
              ...cVal,
            };

            if (cVal?.create_time && cVal?.create_time[0]) {
              where.create_start = moment(cVal?.create_time[0]).format(
                "YYYY-MM-DD 00:00:00"
              );
              where.create_end = moment(cVal?.create_time[1]).format(
                "YYYY-MM-DD 23:59:59"
              );
            } else {
              where.create_start = undefined;
              where.create_end = undefined;
            }

            if (cVal?.set_time && cVal?.set_time[0]) {
              where.execution_start = moment(cVal?.set_time[0]).format(
                "YYYY-MM-DD 00:00:00"
              );
              where.execution_end = moment(cVal?.set_time[1]).format(
                "YYYY-MM-DD 23:59:59"
              );
            } else {
              where.execution_start = undefined;
              where.execution_end = undefined;
            }

            setPagination({
              ...pagination,
              ...where,
            });
            console.log(pagination);
          }}
        >
          <Form.Item
            label={t("pages.taskList.searchLabel1")}
            name="create_time"
          >
            <RangePicker allowClear />
          </Form.Item>
          <Form.Item label={t("pages.taskList.searchLabel2")} name="set_time">
            <RangePicker allowClear />
          </Form.Item>
          <Form.Item label={t("pages.taskList.searchLabel3")} name="status">
            <Select
              style={{ width: "100px" }}
              defaultValue={""}
              options={[
                {
                  label: t("pages.taskList.searchLabel3Value1"),
                  value: "",
                },
                {
                  label: t("pages.taskList.searchLabel3Value4"),
                  value: 0,
                },
                {
                  label: t("pages.taskList.searchLabel3Value2"),
                  value: 1,
                },
                {
                  label: t("pages.taskList.searchLabel3Value3"),
                  value: 2,
                },
              ]}
              allowClear
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              onClick={() => {
                setPagination({
                  ...pagination,
                  pageNo: 1,
                  current: 1,
                });
                getList({
                  ...pagination,
                  pageNo: 1,
                  current: 1,
                });
              }}
            >
              {t("pages.taskList.searchBtn")}
            </Button>
          </Form.Item>
        </Form>
      </div>
      <Table
        rowKey={"id"}
        columns={columns}
        dataSource={dataSource}
        pagination={{
          pageSize: pagination.pageSize,
          total: pagination.total,
        }}
        onChange={paginationChange}
      />
    </div>
  );
};

export default List;
